import {connect} from 'react-redux';
import FullScreenImage, {FullScreenImageProps} from './FullscreenImage';
import ReduxState from '../../types/ReduxState';

const mapStateToProps = (state: ReduxState, ownProps: Partial<FullScreenImageContainerProps>): FullScreenImageProps => {
   return {
      mediaUrl: state.currentReviewVersion.MediaUrl || '',
      onClose: ownProps.onClose
   };
};

export default connect(mapStateToProps, null)(FullScreenImage);

interface FullScreenImageContainerProps {
   onClose(): void;
}